import { request } from '../../request'

//分页查询 调查员结算单
export function getInvestigatorStatementList(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/page',
    method: 'get',
    params
  })
}

//分页查询(费用发放) 调查员结算单
export function getPayPageList(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/payPage',
    method: 'get',
    params
  })
}

//通过id查询调查员结算任务（提交结算单-二级表格）
export function getSettleDetailListById(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/getSettleDetailListById',
    method: 'get',
    params
  })
}

//状态数量统计
export function getStatusInfoCount(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/getStatusInfoCount',
    method: 'get',
    params
  })
}

//费用发放 - 状态数量统计
export function getPayStatusInfoCount(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/getPayStatusInfoCount',
    method: 'get',
    params
  })
}

//更新补扣款
export function updateAdjustment(data) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/adjust',
    method: 'post',
    data
  })
}

//调查员结算单 批量删除
export function removeStatement(data) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/remove',
    method: 'post',
    data
  })
}

//调查员结算单任务明细详情
export function getInvestigatorDetail(id, params) {
  return request({
    url: `/wjsettlement/center/investigatorDetail/detail/${id}`,
    method: 'get',
    params
  })
}

//导航项目名称
export function getInvestigatorDetailTableInfo(params) {
  return request({
    url: `/wjsettlement/center/investigatorDetail/getTableInfo`,
    method: 'get',
    params
  })
}

//分页查询 调查员结算任务明细
export function getInvestigatorDetailList(params, data) {
  return request({
    url: '/wjsettlement/center/investigatorDetail/page',
    method: 'post',
    params,
    data
  })
}

//调查员结算任务明细 批量删除
export function removeInvestigatorDetail(data) {
  return request({
    url: '/wjsettlement/center/investigatorDetail/remove',
    method: 'post',
    data
  })
}

//调查员结算单详情
export function getInvestigatorDetailCardTab(id) {
  return request({
    url: `/wjsettlement/center/investigatorStatement/detail/${id}`,
    method: 'get'
  })
}

//分页查询 答卷/案件
export function getCaseList(params) {
  return request({
    url: `/wjsettlement/center/item/page`,
    method: 'get',
    params
  })
}

//分页查询 计数明细
export function getCountList(params) {
  return request({
    url: `/wjsettlement/center/itemGroup/page`,
    method: 'get',
    params
  })
}

//调查员结算单 批量撤销确认
export function cancelConfirm(data) {
  return request({
    url: `/wjsettlement/center/investigatorStatement/cancelConfirm`,
    method: 'post',
    data
  })
}

//调查员结算单 批量提交确认
export function initiateConfirm(data) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/initiateConfirm',
    method: 'post',
    data
  })
}

//分页查询勾选访问员结算单列表
export function pageForStatementBySelect(params, data) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/pageForStatementBySelect',
    method: 'post',
    params,
    data
  })
}

//提交费用审批
export function startAudit(data) {
  return request({
    url: '/wjsettlement/center/statement/startAudit',
    method: 'post',
    data
  })
}

//提交费用审批
export function cancelAudit(id) {
  return request({
    url: `/wjsettlement/center/statement/cancelAudit/${id}`,
    method: 'get'
  })
}

//明细导出pdf
export function downloadDetailPDF(params) {
  return request({
    url: `/wjsettlement/center/projectExcel/downloadDetail`,
    method: 'get',
    params
  })
}
// 明细导出Excel
export function downloadDetailExcel(params) {
  return request({
    url: `/wjsettlement/center/projectExcel/downloadFeeSettlementDetailExcel`,
    method: 'get',
    params
  })
}
//判断当前结算单下所有访问员是否都认可
export function getJudgeStatus(params) {
  return request({
    url: `/wjsettlement/center/investigatorStatement/judgeStatus`,
    method: 'get',
    params
  })
}

//补扣款明细
export function getSetAdjustPage(params) {
  return request({
    url: `/wjsettlement/center/investigatorStatement/getSettleInvestigatorStatementSetAdjustPage`,
    method: 'get',
    params
  })
}

// 查看人工导入明细
export function importProjectDetail(params) {
  return request({
    url: `/wjsettlement/center/project/partDetail`,
    method: 'get',
    params
  })
}

// 统计代理确认统计
export function getProxyStatistics(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/getStatusInfoCountByEntrust',
    method: 'get',
    params
  })
}

//费用发放 - 批量支付
export function batchPay(data) {
  return request({
    url: '/wjsettlement/center/statement/batchPay',
    method: 'post',
    data
  })
}

//评价 - 更新评价
export function updateEvaluate(data) {
  return request({
    url: '/comment/wjevaluate/updateEvaluate',
    method: 'post',
    data
  })
}

//检测调查员结算单的支付状态
export function checkSettleStage(params) {
  return request({
    url: '/wjsettlement/center/investigatorStatement/checkSettleStage',
    method: 'get',
    params
  })
}

//固定的审核员
export function finalAuditors(data) {
  return request({
    url: '/wjsettlement/settleAuditorConfig/info',
    method: 'post',
    data
  })
}